import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Spin, Tag, Avatar, Tooltip } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";
import Lightbox from "react-image-lightbox";

import ModalUpload from "./ModalUpload";
import ModalUpdate from "./ModalUpdate";

class BannerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerList: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "update", direction: "desc" },
      visbleModalDownload: false,
      imageUrl: null,
      isVisibleImage: null,
      selectedImage: "",
      openModalUpdate: false,
      idBanner: null,
      statusBanner: "",
    };
    this.closeModal = this.closeModal.bind(this);
    this.closeModalUpdate = this.closeModalUpdate.bind(this);
    this.setSelectedImage = this.setSelectedImage.bind(this);
    this.uploadBanner = this.uploadBanner.bind(this);
    this.updateBanner = this.updateBanner.bind(this);
  }

  componentDidMount() {
    this.fetchBannerList(this.state.page, this.state.limit);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.app !== this.props.match.params.app) {
      this.setState(
        {
          isLoading: true,
          search: "",
          page: 1,
          limit: 15,
          sort: { name: "update", direction: "desc" },
        },
        () => this.fetchBannerList(1, 15)
      );
    }
  }

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Hari/Tgl Dibuat") key = "create";
    else if (sort.name === "Hari/Tgl Update") key = "update";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  getApp() {
    let app = this.props.match.params.app;
    if (!["salesman"].includes(app)) app = null;
    return app;
  }

  async fetchBannerList(page, limit) {
    const app = this.getApp();
    if (app) {
      const order = this.orderBy(this.state.sort);
      const query = `${order}&page=${page}&limit=${limit}&search=${
        this.state.search || ""
      }`;
      await axios
        .get(`admin-panel/banner/${app}?${query}`)
        .then(result => {
          this.setState({
            bannerList: result.data.bannerList,
            page: result.data.page,
            limit: result.data.limit,
            count: result.data.count,
            isLoading: false,
          });
        })
        .catch(err => {
          message.error("Gagal request data banner");
          this.setState({ isLoading: false });
        });
    } else {
      message.error("Gagal request data banner");
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchBannerList(page, limit);
  }

  openModal() {
    this.setState({ openModal: true });
  }

  openModalUpdate(id = null, status = null) {
    this.setState({
      openModalUpdate: true,
      idBanner: id,
      statusBanner: status,
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      selectedImage: null,
      disableButton: true,
    });
  }

  closeModalUpdate() {
    this.setState({
      openModalUpdate: false,
      idBanner: null,
      status: null,
    });
  }

  setSelectedImage(image) {
    let disableButton = image ? false : true;
    this.setState({ selectedImage: image, disableButton });
  }

  async uploadBanner(image) {
    if (image) {
      const app = this.props.match.params.app;
      this.setState({ confirmLoading: true });
      let formData = new FormData();
      formData.append("image", image);
      await Axios.post(
        `${process.env.REACT_APP_API_URL}/admin-panel/banner/upload/${app}`,
        formData
      )
        .then(res => {
          message.success(`Berhasil Upload Banner ${app}`);
          this.setState({
            confirmLoading: false,
            openModal: false,
            isLoading: true,
            disableButton: true,
            selectedImage: null,
          });
          this.fetchBannerList(1, this.state.limit);
        })
        .catch(e => {
          if (e.response) {
            if (e.response.data || e.response.message) {
              message.error(
                e.response.data.message || e.response.message || e.response.data
              );
            } else {
              message.error("Error upload banner");
            }
          } else {
            message.error("Error upload banner");
          }
          this.setState({ confirmLoading: false });
        });
    } else {
      message.error("Error upload banner");
    }
  }

  async updateBanner() {
    const { idBanner, statusBanner } = this.state;
    if (idBanner && statusBanner) {
      this.setState({ isLoading: true });
      await Axios.patch(
        `${process.env.REACT_APP_API_URL}/admin-panel/banner/update/${idBanner}`,
        { status: statusBanner }
      )
        .then(res => {
          message.success(`Berhasil Update Banner`);
          this.setState({ openModalUpdate: false });
          this.fetchBannerList(1, this.state.limit);
        })
        .catch(e => {
          if (e.response) {
            if (e.response.data || e.response.message) {
              message.error(
                e.response.data.message || e.response.message || e.response.data
              );
            } else {
              message.error("Error update banner");
            }
          } else {
            message.error("Error update banner");
          }
          this.setState({ isLoading: false });
        });
    } else {
      message.error("Error update banner");
    }
  }

  visibleImageDetail = (key, url = null) => {
    this.setState({
      isVisibleImage: key,
      imageUrl: url,
    });
  };

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "No",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "Image",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Dibuat",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Update",
        options: {
          sort: false,
        },
      },
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
    ];

    //Data New Car
    const bannerList = this.state.bannerList.map((item, idx) => {
      return [
        this.state.limit * (this.state.page - 1) + (idx + 1),
        item.deletedStatus ? (
          <Tag color="red">DELETED</Tag>
        ) : (
          <Tag color="green">ACTIVE</Tag>
        ),
        <Avatar
          size={64}
          src={item.imageUrl}
          onClick={() => this.visibleImageDetail(true, item.imageUrl)}
        />,
        momentTZ(item.createdAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
        <div>
          <Tooltip placement="bottom" title="Active Banner">
            <Button
              type="primary"
              icon="check"
              disabled={!item.deletedStatus}
              onClick={() => this.openModalUpdate(item.id, "Active")}
            />
          </Tooltip>{" "}
          <Tooltip placement="bottom" title="Delete Banner">
            <Button
              type="danger"
              icon="delete"
              disabled={item.deletedStatus}
              onClick={() => this.openModalUpdate(item.id, "Delete")}
            />
          </Tooltip>
        </div>,
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Banner List"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.openModal()} style={{ marginLeft: 10 }}>
            Upload Banner
          </Button>
        </div>

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={`Banner - ${this.props.match.params.app}`}
              data={bannerList}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        {this.state.isVisibleImage && (
          <Lightbox
            mainSrc={this.state.imageUrl}
            onCloseRequest={() => this.visibleImageDetail(false)}
            imagePadding={50}
          />
        )}
        {this.state.openModal && (
          <ModalUpload
            confirmLoading={this.state.confirmLoading}
            isButtonSend={this.state.disableButton}
            selectedImage={this.state.selectedImage}
            visible={this.state.openModal}
            visibleModal={this.closeModal}
            setSelectedImage={this.setSelectedImage}
            uploadBanner={this.uploadBanner}
          />
        )}

        {this.state.openModalUpdate && (
          <ModalUpdate
            modalUpdate={this.state.openModalUpdate}
            status={this.state.statusBanner}
            updateBanner={this.updateBanner}
            closeModal={this.closeModalUpdate}
          />
        )}
      </Card>
    );
  }
}

export default BannerList;



// WEBPACK FOOTER //
// src/components/Dashboard/BannerList/BannerList.js